import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import { useAppliedFilters } from '~/context/srp/AppliedFiltersContext';
import SearchContext from '~/context/srp/SearchContext';
import useRefInView from '~/hooks/common/useRefInView';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';
import useHasSeenNudgeRecently from './useHasSeenNudgeRecently';
import useHasTimePassed from './useHasTimePassed';
import useLoadSaveSearchNudge from './useLoadSaveSearchNudge';

function useHasChanged(value: any): boolean {
  const [hasChanged, setHasChanged] = useState(false);

  useSubsequentEffect(() => {
    setHasChanged(true);
  }, [value]);

  return hasChanged;
}

export default function useShouldShowNudge() {
  const { resultsSectionRef } = useContext(SearchContext);

  const hasThreeOrMoreFilters = Object.keys(useAppliedFilters()).length >= 3;
  const { request } = useGenerateInventoryRequest(0);
  const hasUserInteracted = useHasChanged(request);
  const hasSeenNudgeRecently = useHasSeenNudgeRecently();
  const { hasTimePassed, resetTimer } = useHasTimePassed(
    hasThreeOrMoreFilters && hasUserInteracted,
    request
  );
  const loadSaveSearchNudge = useLoadSaveSearchNudge();
  const resultsSectionBottomInView = useRefInView(resultsSectionRef);

  const timeHasPassedOrUserHasScrolled =
    hasUserInteracted && (hasTimePassed || resultsSectionBottomInView);

  const shouldShowNudge =
    loadSaveSearchNudge &&
    !hasSeenNudgeRecently &&
    hasThreeOrMoreFilters &&
    timeHasPassedOrUserHasScrolled;

  return { reset: resetTimer, shouldShowNudge };
}
